import axios from "axios";

export interface Notification {
  id: number;
  content: {
    body: string;
    title: string;
    data: {
      category: string;
      icon: string;
      message: string;
      redirect: boolean;
      slug: string;
      uri: string;
    };
  };
  type: string;
  read: boolean;
  createdAt: boolean;
}

const apiUrl = process.env.NOTIFICATION_CENTER_URL || "";
const axiosClient = axios.create({
  baseURL: apiUrl,
  timeout: 0,
  headers: {},
});

export async function getNotifications(
  accessToken?: string
): Promise<Notification[]> {
  const response = await axiosClient.get(
    `/notificacoes?page=0&size=10&sort=createdAt%2CDESC&typeName=Portal%20Notification`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "app-key": process.env.APP_KEY || "",
      },
    }
  );

  return response.data.content;
}

export async function markAsRead(
  id: number,
  accessToken?: string
): Promise<Notification[]> {
  const response = await axiosClient.put(
    `/notificacoes/lida/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "app-key": process.env.APP_KEY || "",
      },
    }
  );

  return response.data.content;
}

export async function markAsAllRead(
  ids: number[],
  accessToken?: string
): Promise<Notification[]> {
  const response = await axiosClient.put(`/notificacoes/lida`, ids, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "app-key": process.env.APP_KEY || "",
    },
  });

  return response.data.content;
}
